import { IsJsonString } from 'helpers';
import TrackingService from './TrackingService';
import CacheService from './CacheService';
import { AppRoutes } from 'consts/routesPath';
import { matchPath } from 'helpers/string';
import isString from 'lodash/isString';

const HISTORY_RESEND_KEY = 'HISTORY_RESEND_KEY';
const TRACKING_ELEMENTS_KEY = 'TRACKING_ELEMENTS_KEY';
const FORM_SEND_KEY = 'sending';

class StorageService {
  // Tracking elements
  getTrackingElementsQueue() {
    return sessionStorage.getItem(TRACKING_ELEMENTS_KEY)
      ? JSON.parse(sessionStorage.getItem(TRACKING_ELEMENTS_KEY))
      : {};
  }

  appendTrackingQueue(key, value) {
    try {
      const queue = this.getTrackingElementsQueue();
      queue[key] = {
        ...queue?.[key],
        [value]: queue?.[key]?.[value] ? queue?.[key]?.[value] + 1 : 1,
      };

      sessionStorage.setItem(TRACKING_ELEMENTS_KEY, JSON.stringify(queue));
    } catch (e) {
      console.error(e);
    }
  }

  sendTrackingToServer() {
    //* Call API to track every 30s
    const elements = this.getTrackingElementsQueue();
    TrackingService.insertTrackingElements(elements);

    //* Reset storage
    sessionStorage.setItem(TRACKING_ELEMENTS_KEY, JSON.stringify({}));
  }

  handleElementClicked(e) {
    const parentElement = e.target.closest('button');
    const isParentButton = !!parentElement;
    let shouldAppendTrackingQueue = false;

    let element = isParentButton ? parentElement.outerHTML : e.target.outerHTML;

    if (isParentButton) {
      element = `<button>${parentElement.textContent}</button>`;
      shouldAppendTrackingQueue = true;
    }

    if (element.includes('tracking-el')) {
      const tagName = e.target.tagName.toLowerCase();
      element = `<${tagName}>${e.target.textContent}</${tagName}>`;
      shouldAppendTrackingQueue = true;
    }

    //* user click nav item
    if (element.includes('class="nav-send__item') || element.includes('class="nav-link')) {
      shouldAppendTrackingQueue = true;
    }

    //* user click copy button
    if (element.includes('class="icon-copy')) {
      shouldAppendTrackingQueue = true;
    }

    if (shouldAppendTrackingQueue) {
      let pathShouldAppendToTrack = '';
      //* only track the pathname in approutes
      const isInAppRoutes = Object.values(AppRoutes).some((path) => {
        if (!isString(path)) {
          return false;
        }

        if (matchPath(window.location.pathname, path)) {
          pathShouldAppendToTrack = path;
          return true;
        }
      });

      if (isInAppRoutes) {
        this.appendTrackingQueue(`${pathShouldAppendToTrack}`, element);
      }
    }
  }

  // Resend history
  setResendHistory(history) {
    sessionStorage.setItem(HISTORY_RESEND_KEY, JSON.stringify(history));
  }

  getResendHistory() {
    const cpResend = sessionStorage.getItem(HISTORY_RESEND_KEY);
    if (cpResend) {
      return JSON.parse(cpResend);
    }

    return null;
  }

  removeResendHistory() {
    sessionStorage.removeItem(HISTORY_RESEND_KEY);
  }

  // Campaign compose
  saveFormRecentSend(formValues) {
    const userInfo = CacheService.userInfo;
    localStorage.setItem(`${FORM_SEND_KEY}_${userInfo?.username}`, JSON.stringify(formValues));
  }

  getFormRecentSend() {
    const userInfo = CacheService.userInfo;
    const result = localStorage.getItem(`${FORM_SEND_KEY}_${userInfo?.username}`);
    if (!!result && IsJsonString(result)) {
      return JSON.parse(result);
    }

    return {};
  }
}

export default new StorageService();
